<template>
  <div>
    <h2 class="mb-3">{{ action }} a Partner</h2>

    <div class="row align-items-stretch">
        <div class="col-12 mb-3">
            <!-- Agency Access -->
            <permission-table 
                :user_logged_in="user_logged_in"
                :initialPermissions="agency.access"
                ref="partnerAccess"
                @permission-change="handlePermissionChange"
            />
        </div>
    </div>

    <!-- Error Alert -->
    <div v-if="form.error" class="alert alert-danger mt-3">
      There was an error saving the partner information.
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end gap-2 mb-4">
      <button :disabled="form.busy" @click="update" class="btn btn-primary me-3">
        <span v-if="form.busy" class="d-inline-block spinner-border spinner-border-sm ms-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </span>
        {{ action }} Partner
      </button>

      <button @click="cancel" class="btn btn-white" :disabled="form.busy">Cancel</button>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap';

export default {
  props: {
    client: Object,
    agency: Object,
    user_logged_in: Object,
    mode: { type: String, default: 'add' } // 'add' or 'edit'
  },
  data() {
    return {
        action: this.mode === 'edit' ? 'Update' : 'Add',
        form: {
            successful: false,
            busy: false,
            error: false
        },
    };
  },
  beforeMount() {
    if (this.agency && this.agency.id && this.agency.id > 0) {
        this.action = 'Update';
    }
  },
  updated() {
    // Optionally, re-initialize tooltips on every update
    this.$nextTick(() => {
      this.initTooltips();
    });
  },
  methods: {
    initTooltips() {
        // Remove any existing tooltips to avoid duplicates
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(el => {
            if (el._tooltipInstance) {
                el._tooltipInstance.dispose();
            }
            el._tooltipInstance = new Tooltip(el);
        });
    },
    handlePermissionChange({ section, functionality, value }) {
        // Handle permission changes if needed for agencies
        // Currently agencies don't have notification preferences, but this is here for future use
    },
    update() {
        this.form.busy = true;
        let access = this.$refs.partnerAccess.getPermissions();

        //Update a user
        window.axios.post('/api/client/' +this.client.url + '/update_agency/' + this.agency.id, {access: access}) // TODO new api needed
            .then(response => {

            Swal.fire({
                html: '<h3 class="mb-0">' + this.agency.name + ' has been updated!</h3>',
                icon: 'success',
                showConfirmButton: false,
                customClass: {
                    popup: 'swal-success'
                },
            }).then(() => {
                // Redirect to team screen after Swal closes
                window.location.href = '/settings/' + this.client.url + '/team';
            });
        }).catch(error => {
            this.form.busy = false;
            this.form.error = true;
            setTimeout(() => {this.form.error = false}, 10000);
            
        });
    },
    cancel() {
      window.location.href = '/settings/' + this.client.url + '/team';
    },
  },
};
</script>